import { useContext } from "react";
import styles from "./index.module.scss"
import { GenerateContext } from "../../../hooks/GenerateContext";
import { RESOLUTION_ALIGN } from "@utils/CONST";

export default function SelectGenerateResolution() {
    const {
        resolutionAlign,
        setResolutionAlign
    } = useContext(GenerateContext)

    const items = [{
        value: RESOLUTION_ALIGN.INPUT,
        title: "上传图比例",
        content: "按上传图比例生成",
    }, {
        value: RESOLUTION_ALIGN.BKG,
        title: "参考图比例",
        content: "按已选场景参考图比例生成",
    }]


    return (
        <div className={styles.Container}>
            <p className={styles.Title}>生成图比例</p>
            <div className={styles.PickerContent}>
                {
                    items.map(item => (
                        <div
                            key={item.value}
                            className={`${styles.PickerItem} ${resolutionAlign == item.value && styles.actived}`}
                            onClick={() => setResolutionAlign(item.value)}
                        >
                            <div className={styles.Title}>
                                <span>{item.title}</span>
                            </div>
                            <span className={styles.Content}>{item.content}</span>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}